/// <reference path="skyward.ui.window.js" />

(function (skyward, $, undefined)
{
    'use strict';

    var init = function (selector)
    {
        $(selector + ' .checkbox[indeterminate]').prop('indeterminate', true);
    };

    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery));
